import { defineStore, skipHydrate } from 'pinia'
import { isInternalLanguage, COUNTRIES_LIST, OTHER_COUNTRY_ID } from '@/utils/constants/locale'
import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

const DEFAULT_LANGUAGE = 'en'
const DEFAULT_COUNTRY = 'LV'

export const useLocaleStore = defineStore('localeStore', () => {
  const selectedLanguage = ref<string>('')
  const selectedCountry = ref<string>('')

  let languageCookie = ref<string | undefined>()
  let countryCookie = ref<string | undefined>()

  const isClient = import.meta.client

  const selectedCountrySameAsCookie = computed(() => selectedCountry.value === countryCookie?.value)

  function initCookies() {
    languageCookie = useCookie<string | undefined>('language', { ...COOKIE_OPTIONS })
    countryCookie = useCookie<string | undefined>('country', { ...COOKIE_OPTIONS })

    selectedLanguage.value = languageCookie.value || DEFAULT_LANGUAGE
    selectedCountry.value = countryCookie.value || DEFAULT_COUNTRY
  }

  function setSelectedLanguage(value: string) {
    if (!isInternalLanguage(value) || value === selectedLanguage.value) return
    selectedLanguage.value = value

    if (isClient) languageCookie.value = value
  }

  function setSelectedCountry(value: string) {
    if (!COUNTRIES_LIST.includes(value)) value = OTHER_COUNTRY_ID
    selectedCountry.value = value
    if (isClient) countryCookie.value = value
  }

  function resetSelectedLanguageCountry() {
    selectedLanguage.value = languageCookie.value || DEFAULT_LANGUAGE
    selectedCountry.value = countryCookie.value || DEFAULT_COUNTRY
  }

  if (isClient) {
    queueMicrotask(() => {
      if (!languageCookie.value) languageCookie.value = selectedLanguage.value || DEFAULT_LANGUAGE
      if (!countryCookie.value) countryCookie.value = selectedCountry.value || DEFAULT_COUNTRY
    })
  }

  return {
    selectedCountry: skipHydrate(selectedCountry),
    selectedLanguage,
    selectedCountrySameAsCookie,
    initCookies,
    setSelectedLanguage,
    setSelectedCountry,
    resetSelectedLanguageCountry
  }
})
